/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Badoo - Coneix gent nova, xateja i fes amics",
      "Número de telèfon incorrecte",
      "Get the app",
      "Continuar amb Apple",
      "Continuar amb Facebook",
      "Continuar amb Google",
      "Accedir",
      "Registra't",
      "Per a continuar, si us plau introdueix els caràcters que veus dins del requadre.",
      "Continuar",
      "Escriu els caràcters",
      "Control de seguretat",
      "Recarregar",
      "Crea una nova contrasenya que et sigui fàcil de recordar:",
      "Actualitzar",
      "Confirmar contrasenya",
      "La contrasenya ha de tenir almenys {{num}} [[characters:num]]",
      "Contrasenya",
      "Crear una nova contrasenya",
      "Badoo - The Blog",
      "Treball",
      "Xat",
      "Ciutats",
      "Gestionar les galetes",
      "Copyright © 2006 – present. Bumble. Tots els drets reservats.",
      "Apple i el logotip d'Apple són marques comercials d'Apple Inc.{{__EOL__}}Google Play és una marca comercial de Google LLC.",
      "Descarregar",
      "Facebook",
      "Segueix-nos",
      "Centre d'ajuda",
      "Instagram",
      "Idioma",
      "LinkedIn",
      "Visió general",
      "Badoo forma part de Bumble Inc.",
      "Política de privadesa",
      "Centre de seguretat",
      "Mapa del lloc",
      "Declaració de la Modern Slavery Act",
      "Condicions d’ús",
      "Twitter",
      "Introdueix el teu correu o número de telèfon i t'enviarem les instruccions per a crear una nova contrasenya.",
      "Obtenir una nova contrasenya",
      "Introdueix el teu correu o número de telèfon",
      "Contrasenya oblidada",
      "Models utilitzats només amb finalitats il·lustratives",
      "Get the app",
      "We’re excited to bring renewed support, helpful technology, and safer experiences to help foster relationships formed with greater confidence. This is all part of Badoo’s commitment to being the app that builds dating confidence.",
      "We’ll continue to pioneer dating technology to meet the needs of daters as identified in this report, starting with the release of ‘<b><a href=\"{{url}}\">Deception Detector™</a></b>’, a machine learning model that has demonstrated <b>99.5% precision</b> in combating spam, scam and fake accounts.",
      "We remain <b>committed</b> to the responsible use of Artificial Intelligence (A.I.), ensuring human intelligence comes first and A.I. capabilities don’t damage the <b>authenticity</b> of our community;",
      "We’ll no longer contribute to the creation of dating trends that fuel <b>negative perceptions</b> and <b>behaviours</b>;",
      "We’ll work to identify <b>bad behaviour</b> in dating so we can minimise its impact on our community’s well-being;",
      "We’ll only work with influencer talent who we think are <b>authentic</b> and <b>realistic</b> in how they present themselves online;",
      "Take me to Badoo",
      "Our Confidence Commitments:",
      "We’ve published this report for daters, dating communities, and online platforms—anyone—to be able to use the findings to help people have a kinder, more enjoyable experience with greater possibilities than ever before.",
      "At Badoo, we know there’s work to be done. Our teams have studied findings and are making changes so we can play our part. But there are also immediate commitments we’ve decided to make.",
      "At a pivotal moment when we believe human connection has never been more valuable, and people having confidence in how they can form connections has never been more important, we have created an <b>industry first Dating Confidence Report.</b>",
      "Download the report",
      "Badoo has always been a pioneer in dating, creating one of the first online dating platforms in the world and being the first to reach 100 million downloads.",
      "The report details behaviours, attitudes and influences that have negatively influenced dating, supported by expert guidance on how we can enjoy more of the best parts—and be better equipped to manage (or change) the parts we’d all rather avoid.",
      "Being intentional: relaxing, being present, and being themselves in their dating experiences—on and offline",
      "Being able to ignore what they see on social media, and focus on what works for them;",
      "Feeling they can trust that who they’re seeing or speaking to is for real;",
      "Feeling clear in their own intentions and trusting that their matches are being genuine, too;",
      "Reducing paranoia and hypervigilance about negative dating behaviour;",
      "The key ingredients for greater dating confidence are:",
      "We believe this is the dating world’s biggest barrier to its potential—and our commitment to breaking this barrier has begun. Every year, instead of focusing on dating trends, we’ll track our own progress in building dating confidence and continue to assess the challenges daters face across the industry.",
      "The findings will lead to annual Confidence Commitments and innovations in our product to help minimise dating experiences that damage people’s confidence. Ultimately this’ll help make online dating a kinder, <b><u><a href=\"{{url}}\">safer</a></u></b> and more valuable experience for those who want meaningful connections. Our commitments for 2024 are below.",
      "Read Confidence Commitments",
      "The report shows us in no uncertain terms that dating confidence is at an all-time low for many singles.",
      "No cal que esperis a fer una connexió. {{__EOL__}}{{__EOL__}}Pots passar directament a la part bona, ja saps, aquella on es tenen converses més profundes per a arribar a conèixer-vos de veritat.",
      "A punt per xatejar ara?",
      "En continuar, acceptes les nostres <a class=\"link\" href=\"{{terms_url}}\">Condicions d'ús</a>. Tens més informació sobre com utilitzem les teves dades a la nostra <a class=\"link\" href=\"{{privacy_url}}\">Política de privadesa</a>",
      "T'ajudem a mostrar-te tal com ets, <br />per a tenir trobades autèntiques i on et sentis a gust.",
      "Trobades amb total confiança.",
      "O",
      "Ja tens un compte?",
      "Registra't amb el teu correu o número de telèfon",
      "Aconsegueix el que cerques a les teves trobades.{{__EOL__}}Així de clar, així de senzill.",
      "Només vols xatejar? Perfecte.{{__EOL__}} Cerques quelcom seriós? Genial. {{__EOL__}}{{__EOL__}}I si mai canvies de d’opinió, doncs cap problema!",
      "Per tenir una trobada",
      "A punt per a una relació",
      "Per xatejar",
      "Coneix a algú que vulgui el mateix que tu.",
      "{{name}}, {{age}}",
      "La teva seguretat és la nostra màxima prioritat.",
      "Al nostre Centre de seguretat trobaràs tota la informació que necessites per a tenir trobades amb total confiança.",
      "Visita el nostre Centre de seguretat",
      "La seguretat és el primer,<br/>i el segon. Sempre.",
      "Des del primer moment vaig saber que funcionaria...",
      "Al principi, no buscava res seriós...",
      "Un consell de Badoo per a qualsevol persona de l'aplicació seria: El millor és ser real i tu mateix...",
      "Històries d'èxit de Badoo",
      "Fes una ullada a més històries d'èxit",
      "{{num}}__CUT__Valoració",
      "Apple App Store",
      "Confia en nosaltres. Hem propiciat milions (i milions, i milions) de connexions des del 2006.",
      "Més de {{num}} milions de__CUT__de descàrregues",
      "Més de {{num}} milions",
      "Google Play Store",
      "Sabem el que fem.",
      "Accedeix amb el teu correu o número de telèfon",
      "Introdueix la teva contrasenya",
      "Contrasenya oblidada?",
      "Registra’t",
      "No tens cap compte?",
      "Iniciar sessió",
      "Registra't"
],

    // These are the common words found in the lexemes of the app
    common: {
      "characters": {
            "plural": [
                  "caràcters"
            ],
            "singular": [
                  "caràcter"
            ]
      },
      "day": {
            "plural": [
                  "dies"
            ],
            "singular": [
                  "dia"
            ]
      },
      "hour": {
            "plural": [
                  "hores"
            ],
            "singular": [
                  "hora"
            ]
      },
      "minute": {
            "plural": [
                  "minuts"
            ],
            "singular": [
                  "minut"
            ]
      },
      "month": {
            "plural": [
                  "mesos"
            ],
            "singular": [
                  "mes"
            ]
      },
      "second": {
            "plural": [
                  "segons"
            ],
            "singular": [
                  "segon"
            ]
      },
      "year": {
            "plural": [
                  "anys"
            ],
            "singular": [
                  "any"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
